<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Manage Survey Setting
    </div>
    <!--<div class="page-attributes p-1">
      <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#settingModel" (click)="AddNew()"><i class="fa fa-plus"></i> Add Setting</button>
    </div>-->
    <!--<div class="page-attributes p-1" style="margin-left:10px; margin-top:0;">
      <button type="button"
              class="btn btn-sm btn-primary"
              (click)="openAddSettingModal()">
        <i class="fa fa-plus"></i> Add Setting
      </button>
    </div>-->
    <div class="page-attributes p-1" style="margin-left:10px; margin-top:0;">
      <button class="btn btn-primary btn-action"
              (click)="openAddSettingModal(settingModal)">
        <i class="fa fa-plus"></i> Add Setting
      </button>
    </div>

    <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span id="message"></span>
    </div>


    <div>

      <!-- Using IsgGridComponent for consistent styling (ag-theme-balham) -->
      <isg-grid
        [rowData]="settinglist"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [config]="gridConfig"
        (gridReady)="onGridReady($event)">
      </isg-grid>

      <!--<kendo-grid [data]="settinglist"
                  [sortable]="true"
                  [filterable]="true"
                  [pageable]="{ pageSizes: true, buttonCount: 5 }"
                  [pageSize]="gridPageSize"
                  [skip]="gridSkip"
                  [height]="650"
                  [columnDefs]="columnDefs"
                  (dataStateChange)="onGridReady($event)"
                  (pageChange)="onGridPageChange($event)">
        <kendo-grid-checkbox-column [width]="50" [headerCheckboxSelection]="true"></kendo-grid-checkbox-column>
        <kendo-grid-column *ngFor="let col of columnDefs"
                           [field]="col.field"
                           [title]="col.headerName"
                           [filterable]="col.headerName !== 'Actions'">
        </kendo-grid-column>
      </kendo-grid>-->

    </div>

  </div>

</div>

<!--<div class="modal fade" id="settingModel" tabindex="-1" aria-labelledby="settingModelLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="settingModel">Add Setting</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="settingForm" #f="ngForm">
          <div class="row mb-2">
            <label class="col-md-4 col-form-label">Setting Name</label>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-sm" formControlName="settingName" placeholder="Setting Name" />
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                (click)="CloseForm()">
          <i class="fa fa-remove"></i> Close
        </button>

        <button type="button"
                class="btn btn-primary"
                [disabled]="!settingForm.valid"
                data-bs-dismiss="modal"
                (click)="saveSetting()">
          <i class="fa fa-save"></i> Save
        </button>
      </div>
    </div>
  </div>
</div>-->

<ng-template #settingModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Add Setting</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="settingForm">
      <div class="row mb-3 align-items-center">
        <label for="settingName" class="col-md-4 col-form-label fw-semibold">
          Setting Name <span class="text-danger">*</span>
        </label>
        <div class="col-md-8">
          <input id="settingName" type="text" formControlName="settingName"
                 class="form-control form-control-sm" placeholder="Enter setting name" />
          <small class="text-danger"
                 *ngIf="settingForm.get('settingName')?.invalid && settingForm.get('settingName')?.touched">
            Setting Name is required
          </small>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="settingForm.invalid" (click)="saveSetting()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>

<ng-template #deleteSettingModelConfirmation let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this setting?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss(); CloseForm()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-danger btn-modal" (click)="modal.close(); deleteSetting()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>


